"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStatusMock = void 0;
const uuid_1 = require("uuid");
const enums_1 = require("../../enums");
const pay_status_model_1 = require("./pay-status.model");
const utilities_1 = require("../../utilities");
class PayStatusMock extends pay_status_model_1.PayStatus {
    constructor(data) {
        const ownerId = (0, uuid_1.v4)();
        const seedData = {
            id: (0, uuid_1.v4)(),
            type: enums_1.PayStatusType.AT,
            period: enums_1.PayStatusPeriod.FirstPeriod,
            ownerId,
            ownerType: enums_1.PayStatusOwnerType.Availability,
            ownerRelationIndex: `${ownerId}-${enums_1.PayStatusOwnerType.Availability}-${enums_1.PayStatusPeriod.FirstPeriod}`,
            squadronId: (0, uuid_1.v4)(),
            isConfirmed: false,
            isDuplicated: false,
            date: Date.now(),
            classification: (data === null || data === void 0 ? void 0 : data.classification) || (0, utilities_1.determinePayStatusClassificationByType)(enums_1.PayStatusType.AT),
            ...data,
        };
        super(seedData);
    }
}
exports.PayStatusMock = PayStatusMock;
